import { Type } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { PublicAgentTimelineEvent, PublicAgentNonTimelineEvent } from './envelope.js';
import { AgentSnapshot } from './snapshot.js';
import { InteractionRequestedMessage, InteractionResolvedMessage, InteractionResponseMessage } from './interactions.js';
import { timelineItemsWithUser, UserMessageWithoutOrigin } from './timeline.js';
import { PROTOCOL_VERSION } from './version.js';
export function isSupportedNormalizedVersion(version) {
    return version === PROTOCOL_VERSION || version === '1.5.0' || version === '1.4.0' || version === '1.1.0';
}
const TimelineWithoutOrigin = Type.Object({ ...PublicAgentTimelineEvent.properties, item: timelineItemsWithUser(UserMessageWithoutOrigin) }, { additionalProperties: false });
const Snapshot150 = Type.Object({ ...AgentSnapshot.properties, protocolVersion: Type.Literal('1.5.0') }, { additionalProperties: false });
const interactionSchemas = (version) => Type.Union([
    Type.Object({ ...InteractionRequestedMessage.properties, protocolVersion: Type.Literal(version) }, { additionalProperties: false }),
    Type.Object({ ...InteractionResolvedMessage.properties, protocolVersion: Type.Literal(version) }, { additionalProperties: false }),
    Type.Object({ ...InteractionResponseMessage.properties, protocolVersion: Type.Literal(version) }, { additionalProperties: false }),
]);
const Interactions150 = interactionSchemas('1.5.0');
const Interactions140 = interactionSchemas('1.4.0');
const Interactions110 = interactionSchemas('1.1.0');
const legacyTypes = new Set(['thread_started', 'turn_started', 'turn_completed', 'turn_failed', 'turn_canceled', 'timeline', 'usage_updated', 'runtime_updated', 'interaction_requested', 'interaction_resolved', 'interaction_response']);
function legacyCore(value) {
    if (Array.isArray(value))
        return value.every(legacyCore);
    if (!value || typeof value !== 'object')
        return true;
    return Object.entries(value).every(([key, child]) => !['result', 'settings', 'childSessions', 'redactedFields', 'redacted', 'sensitive', 'clientMessageId', 'origin'].includes(key)
        && !(key === 'kind' && ['form', 'permission_approval', 'external_action'].includes(String(child))) && legacyCore(child));
}
/** Validate committed bytes in their declared schema before adapting a projection copy. */
export function validateNormalizedEventVersion(version, event) {
    if (!isSupportedNormalizedVersion(version) || !event || typeof event !== 'object' || Array.isArray(event))
        return false;
    const value = event;
    if ('protocolVersion' in value && value.protocolVersion !== version)
        return false;
    if (version === PROTOCOL_VERSION)
        return Value.Check(PublicAgentTimelineEvent, event) || Value.Check(PublicAgentNonTimelineEvent, event)
            || Value.Check(AgentSnapshot, event) || Value.Check(InteractionRequestedMessage, event) || Value.Check(InteractionResolvedMessage, event) || Value.Check(InteractionResponseMessage, event);
    if (version !== '1.5.0') {
        if (value.type === 'agent_snapshot' || value.usage && typeof value.usage === 'object' && 'accounting' in value.usage)
            return false;
        if (version === '1.1.0' && (!legacyTypes.has(String(value.type)) || !legacyCore(event)))
            return false;
    }
    return Value.Check(TimelineWithoutOrigin, event) || Value.Check(PublicAgentNonTimelineEvent, event)
        || (version === '1.5.0' && Value.Check(Snapshot150, event))
        || Value.Check(version === '1.5.0' ? Interactions150 : version === '1.4.0' ? Interactions140 : Interactions110, event);
}
//# sourceMappingURL=compatibility.js.map